package features.teams.ui

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import features.teams.domain.Team
import AppState
import Router
import features.teams.handlers.showCreateTeamModal

object TeamListPage {
    fun render(root: HTMLElement) {
        // Load teams from Firestore if not loaded yet
        if (AppState.currentUser != null && !AppState.teamsLoaded && !AppState.isLoading) {
            console.log("📥 Loading teams from Firestore...")
            AppState.isLoading = true
            features.teams.data.TeamRepository.loadUserTeams(AppState.currentUser!!.id)
                .then { teams ->
                    console.log("✅ Teams loaded:", teams.size)
                    AppState.teams.clear()
                    AppState.teams.addAll(teams)
                    AppState.isLoading = false
                    AppState.teamsLoaded = true
                    Router.render()
                }
                .catch { error ->
                    console.error("❌ Error loading teams:", error)
                    AppState.isLoading = false
                    AppState.teamsLoaded = true // Mark as loaded even on error to prevent infinite loop
                    Router.render()
                }
        }
        
        root.append {
            div {
                // Navbar
                shared.ui.components.Navbar.render(this, "TeamMate App", showBackButton = false)
                
                // Dashboard Content
                div("max-w-7xl mx-auto px-4 py-8 pb-32") {
                    div("flex justify-between items-center mb-8") {
                        h2("text-3xl font-bold text-white") { +"My Teams" }
                        button(classes = "bg-brand-cyan hover:bg-brand-green text-white px-6 py-2 rounded-xl font-semibold shadow-lg shadow-cyan-500/20 transition flex items-center gap-2") {
                            onClickFunction = { showCreateTeamModal() }
                            span("text-xl") { +"+" }
                            +"Create Team"
                        }
                    }
                    
                    // Loading state
                    if (AppState.isLoading) {
                        div("text-center py-12") {
                            div("text-4xl mb-4 animate-spin") { +"⏳" }
                            p("text-slate-400") { +"Loading teams..." }
                        }
                    } else if (AppState.teams.isEmpty()) {
                        div("text-center py-12") {
                            img(src = "/images/empty-states/no-teams.png", alt = "No teams yet") {
                                classes = setOf("w-64", "h-64", "mx-auto", "mb-6")
                            }
                            h3("text-xl font-bold mb-2") { +"No Teams Yet" }
                            p("text-slate-400") { +"Create your first team to get started" }
                        }
                    } else {
                        // Teams Grid
                        div("grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6") {
                            AppState.teams.forEach { team ->
                                shared.ui.components.TeamCard.render(this, team)
                            }
                        }
                    }
                }
                
                // Bottom Navigation
                shared.ui.components.BottomNav.render(this)
            }
        }
    }
}
